import React from 'react';

export default function Garage() {
	return (
		<svg className="svg garage" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M7.959 0 1.05 3.07A1.773 1.773 0 0 0 0 4.687V16h5.306v-4.421h5.305V16h5.306V4.686c0-.697-.414-1.332-1.05-1.615l-.002-.002L7.96 0Zm0 1.934 6.19 2.752v9.545H12.38V6.273H3.537v7.958H1.77V4.686l6.19-2.752ZM5.306 8.041h5.305V9.81H8.843v-.884H7.074v.884H5.306V8.041Z" /></svg>
	);
}
